import { MAX_CONTACT_LIMIT, MAX_NAME_LIMIT, MIN_CONTACT_LIMIT, MIN_NAME_LIMIT } from "../constants";
import { containsNumericValue, containsSpecialCharacters, getIntegerValuesFromString, isValidContact } from "../helpers";

export function validateContact(contact, required) {
    if (required && !contact)
        return "Contact number is required"

    else if (contact && !isValidContact(contact))
        return "Contact number is not valid"

    else if (contact && getIntegerValuesFromString(contact).length < MIN_CONTACT_LIMIT)
        return `Contact connot be less than ${MIN_CONTACT_LIMIT} digits`

    else if (contact && getIntegerValuesFromString(contact).length > MAX_CONTACT_LIMIT)
        return `Contact connot be more than ${MAX_CONTACT_LIMIT} digits`

    else return false
}

export function validateName(name, required) {
    if (required && (!name || !name.replaceAll(" ", "")))
        return "Name is required"

    else if (name) {
        if (containsNumericValue(name))
            return "Name can not contain numeric characters"

        else if (containsSpecialCharacters(name))
            return "Name can not contain special characters except space"

        else if (name.replaceAll(" ", "").length < MIN_NAME_LIMIT)
            return `Name connot have less than ${MIN_NAME_LIMIT} characters`

        else if (name.replaceAll(" ", "").length > MAX_NAME_LIMIT)
            return `Name connot have more than ${MAX_NAME_LIMIT} characters`
    }

    else return false
}